const global_func = require('./globals.js');

import { floatThead } from 'floatthead';

jQuery(document).ready(function($) {

  //trigger resize when fonts loaded
  document.addEventListener("DOMContentLoaded", (event) => {
    resize_diary();
  });
  document.fonts.onloadingdone = () => {
    resize_diary();
  };

  $('body').on('diary-loaded', '.get-diary-form', function(event) {
    event.preventDefault();
    make_draggable_diary();
    resize_diary();
    $('.diary-hold table').floatThead({
      responsiveContainer: function($table){
        return $table.closest('.table-responsive');
      },
      top: $('.top-navbar').outerHeight(),
      autoReflow: true,
      zIndex: 100
    });
    $('.diary-hold table').floatThead('reflow');
    resize_diary();
  });

  $(window).on('resize', function(){
    waitForFinalEvent(function(){
      resize_diary();
    }, 500, "window-diary-resize");
  });

  const tabEl = document.querySelector('#nav-diary-tab');
  if(tabEl) {
    tabEl.addEventListener('shown.bs.tab', event => {
      setTimeout(() => {
        $('.diary-hold table').floatThead('reflow');
        resize_diary();
      }, "500");
    })
  }

  $('body').on('click', '.date-links a', function(event) {
    event.preventDefault();
    $('form.get-diary-form input[name="date"]').val($(this).attr('data-date'));
    global_func.change_diary_date($('form.get-diary-form'));
  });

  $('body').on('click', '.diary-input-hold button', function(event) {
    event.preventDefault();
    if($(this).attr('data-date')) {
      $('form.get-diary-form input[name="date"]').val($(this).attr('data-date'));
      $(this).attr('data-date', '');
      global_func.change_diary_date($('form.get-diary-form'));
    }
  });
  
  if(window.moveBookingModal) {
    window.moveBookingModal.addEventListener('hidden.bs.modal', event => {
      resize_diary();
    });
  }

  $('body').on('submit', '#moveBookingModal form', function(event) {
    event.preventDefault();
    move_booking($(this).find('input[name="booking_id"]').val(), $(this).find('input[name="time"]').val(), $(this).find('input[name="tables"]').val(), 1);
    window.moveBookingModal.hide();
  });
});

var waitForFinalEvent = (function () {
  var timers = {};
  return function (callback, ms, uniqueId) {
    if (!uniqueId) {
      uniqueId = "Don't call this twice without a uniqueId";
    }
    if (timers[uniqueId]) {
      clearTimeout (timers[uniqueId]);
    }
    timers[uniqueId] = setTimeout(callback, ms);
  };
})();

function make_draggable_diary() {
  $('body .diary-hold .bookings .booking').each(function(index, el) {
    $(el).draggable({ handle: '.covers', scroll: true, snap: 'body .diary-hold table td.time', snapMode: "inner", snapTolerance: 10, revert: "invalid" });
  });

  $('body .diary-hold table td.time').each(function(index, el) {
    $(el).droppable({
      accept: ".booking",
      tolerance: 'pointer',
      drop: function( event, ui ) {
        var eltop = $(this).offset().top-$('body .diary-hold').offset().top+1;
        var elleft = $(this).offset().left-$('body .diary-hold').offset().left+1;
        ui.draggable.css({top: eltop, left: elleft});
        move_booking(ui.draggable.attr('data-booking-id'), $(this).attr('data-time'), $(this).parent().attr('data-table-number'));
      }
    });
  });
}

function move_booking(booking_id, time, table_number, confirmed=0){
  let data = {};
  data['booking_id'] = booking_id;
  data['time'] = time;
  data['tables'] = table_number;
  data['confirmed'] = confirmed;
  data['_token'] = $('.booking-form input[name="_token"]').val();
  $.ajax({
    url: 'move-booking-ui',
    method: 'PUT',
    data: data,
    dataType: 'JSON',
    cache: false,
    processData: true,
    success:function(response)
    {
      if(response.message) {
        $('#bookingErrorModal .error-modal-hold').html(response.message);
        window.bookingErrorModal.show();
        $('.get-diary-form').trigger('submit', [true]);
      }
      if(response.confirm) {
        if(window.moveBookingModal) {
          window.moveBookingModal.show();
          $('#moveBookingModal input[name="booking_id"]').val(booking_id);
          $('#moveBookingModal input[name="time"]').val(time);
          $('#moveBookingModal input[name="tables"]').val(table_number);
          $('#moveBookingModal').find('.move-booking-message-results').html(response.confirm);
        }
      }
      if(response.success) {
        $('.get-diary-form').trigger('submit', [true]);
      }
    },
    error: function(response) {
      console.log(response);
    }
  });
}

function resize_diary() {
  $('body .diary-hold .bookings .booking.linked').remove();
  $('body .diary-hold .bookings .booking').each(function(index, el) {
    var tables = JSON.parse($(el).attr('data-tables'));
    var prev_table = false;
    var add_height = 0;

    $.each(tables, function(tables_index, val) {
      var table_row = $('body .diary-hold').find('tr[data-table-number="'+ val +'"]')[0];

      if(!table_row || $(table_row).hasClass('no-table')) {
        if(!table_row) {
          table_row = $('body .diary-hold').find('tr[data-table-number="none"]').first().clone().appendTo('body .diary-hold table tbody');
          table_row.attr('data-table-number', val);
          table_row.find('td').first().html(val);
        }
        $(table_row).removeClass('hidden');
        $('body .diary-hold').find('tr.unknown-tables-row').removeClass('hidden');
      }

      if(tables_index > 0) {
        if(prev_table) {
          if($(table_row).prev().attr('data-table-number') != prev_table) {
            el = $(el).clone().appendTo('body .diary-hold .bookings').addClass('linked');
            $(el).find('.covers').html('<i class="fa-solid fa-link"></i>');
            add_height = 0;
          } else {
            add_height = $(table_row).outerHeight();
          }
        }
      }
      
      if(table_row) {
        var table_row_position = $(table_row).position();
        if(!prev_table || $(table_row).prev().attr('data-table-number') != prev_table) {
          $(el).css('top', table_row_position.top + 1);
          $(el).css('height', $(table_row).outerHeight()-1);
        }
        $(el).css('height', $(el).outerHeight() + add_height);

        var times = $(table_row).find('td[data-time]');
        var times_array = [];
        $.each(times, function(index, time_td) {
          times_array.push($(time_td).attr('data-time'));
        });

        if(times_array.length > 0) {
          var booking_time = parseInt($(el).attr('data-time'));
          var end_time = parseInt($(el).attr('data-time-end'));
          var turnaround_time = parseInt($(el).attr('data-time-turnaround'));
          var closest = null;
          var closest_end = null;
          var closest_turnaround = null;

          //get closest start and end times to diary slots
          $.each(times_array, function(index, val){
            if (closest == null || Math.abs(parseInt(val) - booking_time) < Math.abs(closest - booking_time)) {
              closest = parseInt(val);
            }

            if (closest_end == null || Math.abs(parseInt(val) - end_time) < Math.abs(closest_end - end_time)) {
              closest_end = parseInt(val);
            }

            if (closest_turnaround == null || Math.abs(parseInt(val) - turnaround_time) < Math.abs(closest_turnaround - turnaround_time)) {
              closest_turnaround = parseInt(val);
            }
          });

          var time_column = $(table_row).find('td[data-time="'+ closest +'"]')[0];
          var end_time_column = $(table_row).find('td[data-time="'+ closest_end +'"]')[0];
          var turnaround_time_column = $(table_row).find('td[data-time="'+ closest_turnaround +'"]')[0];
          if(time_column && end_time_column && turnaround_time_column) {
            var time_column_position = $(time_column).position();
            var end_time_column_position = $(end_time_column).position();
            var turnaround_time_column_position = $(turnaround_time_column).position();
            var booking_width = (turnaround_time_column_position.left) - time_column_position.left;
            var turnaround_width = (turnaround_time_column_position.left + $(turnaround_time_column).outerWidth()) - (end_time_column_position.left + $(end_time_column).outerWidth());
            $(el).css('left', time_column_position.left);
            $(el).css('width', booking_width-1);
            $(el).find('.turnaround').css('width', turnaround_width);
          }
        }
      }


      prev_table = val;
    });
  });
}